
class ProductUpsell extends HTMLElement {
    constructor() {
        super();
        this.handleIntersection = this.handleIntersection.bind(this);
    }

    connectedCallback() {
        this.dom = {
            container: this.querySelector('.gtc-product-upsell__container'),
        };
        this.settings = {
            productId: this.dataset.productId,
            intent: this.dataset.intent,
            limit: this.dataset.limit,
        };

        this.observe();
    }

    observe() {
        const observer = new IntersectionObserver(this.handleIntersection, {
            rootMargin: '0px 0px 200px 0px'
        });
        observer.observe(this);
    }

    handleIntersection(entries, observer) {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        const url = `${ window.Shopify.routes.root }recommendations/products?product_id=${ this.settings.productId }&limit=${ this.settings.limit }&section_id=gtc-product-recommendations&intent=${ this.settings.intent }`;

        fetch(url)
            .then(response => response.text())
            .then(text => {
                const html = document.createElement('div');
                html.innerHTML = text;
                const recommendations = html.querySelector('.gtc-product-upsell__recommendations');
                if (recommendations && recommendations.innerHTML.trim().length) {
                    this.dom.container.innerHTML = recommendations.innerHTML;
                }
            })
            .catch(e => {
                console.error(e);
            });
    }

}

if (!window.customElements.get("gtc-product-upsell")) {
    window.customElements.define("gtc-product-upsell", ProductUpsell);
}